import { BarChart3, LayoutDashboard, Layers, MessageSquare, ScrollText, Swords } from 'lucide-react';
import { NavLink } from 'react-router-dom';

import { cn } from '@/lib/utils';

const ITEMS = [
  { to: '/', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/matches', label: 'Matches', icon: Swords },
  { to: '/decks', label: 'Decks', icon: Layers },
  { to: '/meta', label: 'Meta', icon: BarChart3 },
  { to: '/chat', label: 'Chat', icon: MessageSquare },
  { to: '/logs', label: 'Activity', icon: ScrollText },
];

export function Sidebar() {
  return (
    <aside
      aria-label="Section navigation"
      className="hidden border-r border-ugin-border/60 bg-ugin-bg-deep/40 px-4 py-6 md:block"
    >
      <ul className="space-y-1">
        {ITEMS.map(({ to, label, icon: Icon }) => (
          <li key={to}>
            <NavLink
              to={to}
              end={to === '/'}
              className={({ isActive }) =>
                cn(
                  'group flex items-center gap-3 rounded-lg px-3 py-2 text-sm transition-colors',
                  'hover:bg-ugin-surface hover:text-ugin-text',
                  isActive
                    ? 'bg-ugin-surface text-ugin-text shadow-[inset_2px_0_0_var(--color-ugin-accent)]'
                    : 'text-ugin-text-muted',
                )
              }
            >
              <Icon className="size-4 shrink-0" aria-hidden="true" />
              <span>{label}</span>
            </NavLink>
          </li>
        ))}
      </ul>

      <div className="mt-10 rounded-xl border border-ugin-border bg-ugin-surface/40 p-4 text-xs text-ugin-text-muted">
        <p className="font-display text-base text-ugin-text">Spirit Dragon</p>
        <p className="mt-2 leading-relaxed">
          Ugin watches the meta so you can build with intention.
        </p>
      </div>
    </aside>
  );
}
